/**
 * 支付方式工具函数（精简自 H5 src/composables/payment/composables/paymentUtils.ts）
 */
import type { Ref } from 'vue'
import { PAYMENT_METHOD_NAMES, PAYMENT_METHOD_PAY_TYPES, PaymentMethodEnum, TOPUP_API_ENDPOINTS } from './constants'

export function initializePaymentMethod(
  currentPaymentMethod: Ref<number>,
  productLists: Ref<any[]>,
  hasPayPalPasswordlessPayment: Ref<boolean>,
  hasPlacedOrder: Ref<boolean>,
) {
  if (hasPayPalPasswordlessPayment.value) {
    const paypalLists = productLists.value.filter(list => list.paymentMethod === PaymentMethodEnum.PAYPAL)
    if (paypalLists.length > 0) {
      currentPaymentMethod.value = PaymentMethodEnum.PAYPAL
    }
    else {
      const stripeLists = productLists.value.filter(list => list.paymentMethod === PaymentMethodEnum.STRIPE)
      currentPaymentMethod.value = stripeLists[0]?.paymentMethod || PaymentMethodEnum.PAYPAL
    }
    return
  }
  if (hasPlacedOrder.value) {
    currentPaymentMethod.value = productLists.value[0]?.paymentMethod || PaymentMethodEnum.PAYPAL
    return
  }
  const defaultPaymentMethods = productLists.value.filter(list => list.defaultDisplay === 1)
  if (defaultPaymentMethods.length > 0)
    currentPaymentMethod.value = defaultPaymentMethods[0].paymentMethod

  else
    currentPaymentMethod.value = productLists.value[0]?.paymentMethod || PaymentMethodEnum.PAYPAL
}

export function createAvailablePaymentMethods(
  productLists: Ref<any[]>,
  hasPayPalPasswordlessPayment: Ref<boolean>,
  hasPlacedOrder: Ref<boolean>,
) {
  return () => {
    const lists = productLists.value
    if (hasPayPalPasswordlessPayment.value) {
      const paypalLists = lists.filter(list => list.paymentMethod === PaymentMethodEnum.PAYPAL)
      if (paypalLists.length === 0)
        return lists.filter(list => list.paymentMethod === PaymentMethodEnum.STRIPE)

      return paypalLists
    }
    if (hasPlacedOrder.value)
      return lists
    const defaultDisplayLists = lists.filter(list => list.defaultDisplay === 1)
    if (defaultDisplayLists.length > 0)
      return defaultDisplayLists
    return lists
  }
}

export function createSelectPaymentMethod(currentPaymentMethod: Ref<number>) {
  return (method: number) => {
    currentPaymentMethod.value = method
  }
}

export function getTopupPaymentApi(paymentMethod: number): string {
  return TOPUP_API_ENDPOINTS[paymentMethod] || TOPUP_API_ENDPOINTS[PaymentMethodEnum.PAYPAL]
}

export function getPayType(paymentMethod: number): number {
  return PAYMENT_METHOD_PAY_TYPES[paymentMethod] || 6
}

export function getPaymentChannelName(paymentMethod: number): string {
  return PAYMENT_METHOD_NAMES[paymentMethod] || 'paypal'
}
